export enum CompanyClientType{
    PORTCONTROL = "PORTCONTROL",
    WHOLESALE = "WHOLESALE"
}